/**
 * Converts radians to degress
 *
 * @param radians - The value in radians
 * @returns - The value in degrees
 */
export function radiansToDegrees(radians: number): number {
    return radians * (180 / Math.PI);
}
